<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div class="row-col">

    <a 
      data-dismiss="modal" 
      class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
    <div class="p-a b-b">
      <span class="h5 text-capitalize">{{ discountExists(discount.id) ? 'Update' : 'Create' }} Discount</span>
    </div>

    <div class="row-row">
      <div class="row-body">
        <div class="row-inner">
          <div class="p-a">
          
            <div 
              :class="{'invalid':errors.has('name')}" 
              class="md-form-group">
              <input 
                v-validate="'required'" 
                :disabled="loading" 
                v-model="discount.name" 
                type="text" 
                name="name" 
                class="md-input">
              <label>Name</label>
              <span 
                v-show="errors.has('name')" 
                class="form-error-msg">{{ errors.first('name') }}</span>
            </div>

            <div class="md-form-group">
              <select 
                :disabled="loading" 
                v-model="discount.mode" 
                class="md-input">
                <option 
                  v-for="mode in modes" 
                  :value="mode.id" 
                  :key="mode.id">
                  {{ mode.name }}
                </option>
              </select>     
              <label for="pricing">Mode</label>
            </div>

            <div 
              :class="{'invalid':errors.has('amount')}" 
              class="md-form-group">
              <input 
                v-validate="{ required: true, decimal: true, min_value: 0 }" 
                :disabled="loading" 
                v-model="discount.amount" 
                type="text" 
                name="amount" 
                min="0"
                data-vv-as="Amount"
                class="md-input"
                @input="$validator.validate('amount')">
              <!-- <label>Amount ( {{ discount.mode == 3 ? '%' : currency }} )</label> -->
              <!-- Remove temporary label -->
              <label :class="{'text-danger': errors.has('amount')}">Amount</label>
              <span 
                v-show="errors.has('amount')" 
                class="form-error-msg text-danger">{{ errors.first('amount') || 'This value should be greater than or equal to 0.' }}</span>
            </div>
            
            <time-picker
              id="available_from"
              ref="available_from"
              :date-to-compare="discount.available_to"
              :rules="{ date_format: 'h:mm A'}"
              name="Available from"
              label="Available from"
              input-to-compare="Available to"
              @onChange="setAvailableFrom"
            />

            <time-picker
              id="available_to"
              ref="available_to"
              :date-to-compare="discount.available_from"
              :rules="{ date_format: 'h:mm A', after: 'Available from'}"
              :icon="'&#xE426;'"
              label="Available to"
              name="Available to"
              @onChange="setAvailableTo"
            />

            <div class="md-form-group">
              <label class="typo__label multiselect-label">Applicable outlets</label>
              <multiselect
                v-model="discount.outlets"
                :options="outletList"
                :multiple="true"
                :loading="outletList.length === 0"
                :clear-on-select="false"
                :close-on-select="false"
                :hide-selected="true"
                placeholder="Type to search"
                label="name"
                track-by="id"/>
              <span class="md-input-msg">Leave empty if applicable to all outlets.</span>
            </div>

            <div class="md-form-group">
              <label class="typo__label multiselect-label">Applicable tags</label>
              <multiselect 
                v-model="discount.tags" 
                :options="tags" 
                :multiple="true" 
                :loading="ajaxTagLoading" 
                :clear-on-select="false"
                :close-on-select="false" 
                :hide-selected="true" 
                placeholder="Type to search" 
                label="name" 
                track-by="id"
                @search-change="loadTags"/>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="p-a b-t">
      <div class="text-right">
        <button 
          :disabled="loading" 
          class="btn btn-fw white" 
          data-dismiss="modal">Cancel</button>
        <button 
          :disabled="loading || !canManageDiscounts"
          class="btn btn-fw primary" 
          @click="submit()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Auth from '@js/plugins/auth';
import modes from './mode';

export default {
    props: {
        currency: {
            type: String,
            default: 'RM',
        },

        discount: {
            required: true,
            type: Object,
        },
    },

    data() {
        return {
            ajaxTagLoading: false,
            tags: [],
            loading: false,
            modes: modes,
        };
    },

    computed: {
        ...mapGetters(['outletList']),

        canManageDiscounts() {
            return Auth.hasPermissionTo('franchise_manage_discounts');
        },
    },

    watch: {
        discount() {
            this.clearErrorValidation();
        },
    },

    mounted() {
        this.loadTags(null);
        this.getOutletList();

        // Custom validation message for min_value
        this.$validator.localize('en', {
            custom: {
                amount: {
                    min_value:
                        'This value should be greater than or equal to 0.',
                },
            },
        });
    },

    methods: {
        submit() {
            var that = this;
            var validateStatus = true;
            this.loading = true;

            if (this.isValidTime()) {
                validateStatus = false;
            }

            this.$validator.validateAll().then(result => {
                if (result && validateStatus) {
                    var submittedValue = this.getSumbittedValue();

                    that.$http[this.getSumbitMethod()](
                        that.getDiscountApi(submittedValue.id),
                        submittedValue,
                    ).then(
                        response => {
                            if (response.status == '200') {
                                let data = response.data.data;
                                if (!that.discountExists(submittedValue.id)) {
                                    that.$parent.init_discount();
                                } else {
                                    $('#discount-popup').modal('hide');
                                }

                                let msg =
                                    'Discount has been successfully ' +
                                    (!that.discountExists(submittedValue.id)
                                        ? 'created'
                                        : 'updated');
                                toastr.success(msg);
                                this.$parent.refresh();
                                that.loading = false;
                            }
                        },
                        error => {
                            toastr.error(error.statusText);
                            that.loading = false;
                        },
                    );
                } else {
                    that.loading = false;
                }
            });
        },

        discountExists(id) {
            return id != 0 && id != undefined;
        },

        getDiscountApi(id) {
            if (this.discountExists(id)) {
                return Laroute.route('franchise.setting.discount.update', {
                    id: id,
                });
            } else {
                return Laroute.route('franchise.setting.discount.store');
            }
        },

        loadTags: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.tags');
            let options = {
                params: {
                    query: query,
                    limit: 30,
                },
            };

            this.ajaxTagLoading = true;
            this.$http.get(api, options).then(response => {
                this.tags = response.data.data;
                this.ajaxTagLoading = false;
            });
        }, 500),

        clearErrorValidation() {
            var that = this;
            setTimeout(() => {
                that.errors.clear();
            }, 50);
        },

        setAvailableFrom(date) {
            if (!date) {
                this.discount.available_from = null;
            } else {
                this.discount.available_from = date.format('h:mm A');
            }
        },

        setAvailableTo(date) {
            if (!date) {
                this.discount.available_to = null;
            } else {
                this.discount.available_to = date.format('h:mm A');
            }
        },

        clearTimePicker() {
            this.$refs.available_to.clear();
            this.$refs.available_from.clear();
        },

        setTimePickerValue(discount) {
            if (!_.isEmpty(discount.available_from)) {
                this.$refs.available_from.setValue(discount.available_from);
            } else {
                this.$refs.available_from.clear();
            }

            if (!_.isEmpty(discount.available_to)) {
                this.$refs.available_to.setValue(discount.available_to);
            } else {
                this.$refs.available_to.clear();
            }
        },

        converTimeToHHMMSS() {
            if (!_.isEmpty(this.discount.available_from)) {
                this.discount.available_from = moment(
                    this.discount.available_from,
                    'h:mm A',
                ).format('HH:mm:ss');
            }
            if (!_.isEmpty(this.discount.available_to)) {
                this.discount.available_to = moment(
                    this.discount.available_to,
                    'h:mm A',
                ).format('HH:mm:ss');
            }
        },

        getSumbitMethod() {
            return this.discountExists(this.discount.id) ? 'patch' : 'post';
        },

        isValidTime() {
            return (
                this.$refs.available_from.hasError() ||
                this.$refs.available_to.hasError()
            );
        },

        getSumbittedValue() {
            this.converTimeToHHMMSS();
            return {
                id: this.discount.id,
                name: this.discount.name,
                amount: this.discount.amount,
                available_from: this.discount.available_from,
                available_to: this.discount.available_to,
                mode: this.discount.mode,
                outlets: this.discount.outlets.map(outlet => outlet.id),
                tags: this.discount.tags.map(tag => tag.id),
            };
        },

        ...mapActions(['getOutletList']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/discount/form.vue